import React from "react";
import { Field, reduxForm, reset } from "redux-form";
import { connect } from "react-redux";
import lodash, { result } from "lodash";
import MUIDataTable from "mui-datatables";
import { plugins, crmValidator, loader, alert as customAlert } from "helpers";
import { reportActions } from "actions";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import MTablestyles from "assets/jss/material-dashboard-pro-react/customMTableStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CloudDownload from "@material-ui/icons/CloudDownload";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { reportServices } from 'services';

import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.jsx";


const style = {};
const THEME = createMuiTheme(MTablestyles);
const FORM_NAME = "FORM_FILTER_TRUE_MONEY_PAYMENT";

class TrueMoneyPaymentReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 10,
            filter: {
                skip: 0,
                limit: 10,
                sortBy: "created_at",
                sortDir: "desc",
                keyword: "",
            },
            csvData: [],
        };
        this.csvLink = React.createRef();
        this.delayedCallback = lodash.debounce(this.getData, 800);
    }

    componentDidMount() {
        const { dispatch, trueMoneyPaymentReport } = this.props;
        const { tableFilter } = trueMoneyPaymentReport;
        
        dispatch(reportActions.getTrueMoneyPaymentList(tableFilter));
    }


    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(reset(FORM_NAME))
        dispatch({ type: "CLEAR_TRUE_MONEY_FILTER" })
    }


    handleSubmit(values) { 
        const { dispatch, trueMoneyPaymentReport } = this.props;
        const { tableFilter } = trueMoneyPaymentReport;
        let _tableFilter = {
            page: 0,
            skip: 0,
            limit: tableFilter.limit,
            sortBy: "created_at",
            sortDir: "desc",
            keyword: "",
            search: values
        }
        const resetTable = true;
        dispatch(reportActions.getTrueMoneyPaymentList(_tableFilter, resetTable));
    }


    clearFilter = () => {
        const { dispatch, trueMoneyPaymentReport } = this.props;
        const { tableFilter } = trueMoneyPaymentReport;
        let _tableFilter = {
            page: 0,
            skip: 0,
            limit: tableFilter.limit,
            sortBy: "created_at",
            sortDir: "desc",
        }
        dispatch(reset(FORM_NAME))
        dispatch({ type: "CLEAR_TRUE_MONEY_FILTER" })
        dispatch(reportActions.getTrueMoneyPaymentList(_tableFilter));
    };

    exportCSV() {
        const { trueMoneyPaymentReport, dispatch } = this.props;
        let { tableFilter, tableTotal } = trueMoneyPaymentReport;
        tableFilter.skip = 0;
        tableFilter.limit = tableTotal ? tableTotal : 100000;
        if (tableTotal > 30000) {
            customAlert(
                dispatch,
                "error",
                "Can not export data more than 30,000 rows"
            );
        } else {
            loader(dispatch, true);
            reportServices
                .downloadTrueMoneyPayment(tableFilter)
                .then((response) => {
                    loader(dispatch, false);
                })
                .catch((e) => {
                    this.setState({ csvData: [] });
                });
        }
    }

    
    getData(skip, limit, sortBy, sortDir, keyword) {
        const { dispatch, tableReload, trueMoneyPaymentReport } = this.props;
        let { tableFilter } = trueMoneyPaymentReport;
        let newFilter = tableFilter;
        
        if (!tableReload) {
            if (crmValidator.isEmptyValue(skip)) {
                newFilter.skip = 0;
            }

            if (crmValidator.isEmptyValue(limit)) {
                newFilter.limit = 10;
            }
            newFilter.page = skip;
            this.setState({
                rowsPerPage: limit,
            });
            skip = parseInt(limit) * parseInt(skip);

            newFilter.skip = skip;
            newFilter.limit = limit;

            if (!crmValidator.isEmptyValue(sortBy)) {
                newFilter.sortBy = sortBy;
            }

            if (!crmValidator.isEmptyValue(sortDir)) {
                newFilter.sortDir = sortDir;
            }

            if (!crmValidator.isEmptyValue(keyword)) {
                newFilter.keyword = keyword;
            } else {
                newFilter.keyword = "";
            }
        } else {
            newFilter = this.state.newFilter
        }

        // console.log(newFilter);
        dispatch(reportActions.getTrueMoneyPaymentList(newFilter));

        this.setState({
            isLoading: true,
            filter: newFilter,
        });
    }

    getRowData(rowIndex = 0) {
        const { trueMoneyPaymentReport } = this.props;
        const { tableData } = trueMoneyPaymentReport;
        const data = tableData;
        return data[rowIndex];
    }

    render() {
        const {
            FORM_FILTER_TRUE_MONEY_PAYMENT,
            handleSubmit,
            trueMoneyPaymentReport
        } = this.props;
        const { rowsPerPage } = this.state;

        let startMaxDate = null;
        if (lodash.has(FORM_FILTER_TRUE_MONEY_PAYMENT, "values.endDate")) {
            startMaxDate = FORM_FILTER_TRUE_MONEY_PAYMENT.values.endDate;
        }

        let endMinDate = null;
        if (lodash.has(FORM_FILTER_TRUE_MONEY_PAYMENT, "values.startDate")) {
            endMinDate = FORM_FILTER_TRUE_MONEY_PAYMENT.values.startDate;
        }
        
        let lineRegisterTypeList = [{
            value: "",
            label: "All"
        },{
            value: "new",
            label: "New"
        },{
            value: "transferFromAgency",
            label: "Transfer (Agency)"
        },{
            value: "transferFromOnline",
            label: "Transfer (Online)"
        }];

        let packageList = [{
            value: "",
            label: "All"
        },{
            value: "LINEOA_BASIC1280",
            label: "Basic"
        },{
            value: "LINEOA_PRO1780",
            label: "Pro"
        }];

        let typeList = [{
            value: "",
            label: "All"
        },{
            value: "บุคคลธรรมดา",
            label: "บุคคลธรรมดา"
        },{
            value: "นิติบุคคล",
            label: "นิติบุคคล"
        }];
        
        let paymentTypeList = [{
            value: "",
            label: "All"
        },{
            value: "firstPayment",
            label: "1'st Payment"
        },{
            value: "recurring",
            label: "Recurring"
        },{
            value: "unsubscribe",
            label: "Unsubscribe"
        }];

        let statusList = [{
            value: "",
            label: "All"
        },{
            value: "success",
            label: "Success"
        },{
            value: "fail",
            label: "Fail"
        }];

        const { tableData, tableTotal, tableFilter } = trueMoneyPaymentReport;
        const columns = [
            // {
            //     name: "created_at",
            //     label: "Date/Time",
            //     options: {
            //         customBodyRender: (value) =>
            //         value ? plugins.datetimeFormat(value, "fulldatetime") : "",
            //     },
            // },
            {
                name: "notify_id",
                label: "Transaction ID",
                options: {
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return lodash.get(rowData, 'notify_id', '-') 
                    }
                }
            },
            {
                name: "product_ref1",
                label: "Reference ID",
                options: {
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return lodash.get(rowData, 'payload.metadata.product_ref1') 
                    }
                }
            },
            {
                name: "package",
                label: "Price Plan",
                options: {
                    filter: false, 
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return (lodash.get(rowData, 'registersData.package') == 'LINEOA_PRO1780' ? "PRO" : "BASIC")
                    }
                }
            },
            {
                name: "lineRegisterType",
                label: "LINE OA Type",
                options: {
                    filter: false, 
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        if(rowData.registersData.lineRegisterType === 'transferFromAgency'){
                            return 'Transfer (Agency)'
                        } else if (rowData.registersData.lineRegisterType === 'transferFromOnline') {
                            return 'Transfer (Online)'
                        } else {
                            return 'New'
                        }
                    }
                }
            },
            {
                name: "type",
                label: "Application Type",
                options: {
                    filter: false, 
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return (lodash.get(rowData, 'registersData.type') == 'corporation' ? "นิติบุคคล" : "บุคคลธรรมดา")
                    }
                }
            },
            {
                name: "email",
                label: "Applivcant E-mail",
                options: {
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return lodash.get(rowData, 'registersData.email')
                    }
                }
            },
            {
                name: "name",
                label: "Applicant Name",
                options: {
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return (rowData.registersData.firstName ? lodash.get(rowData, 'registersData.firstName')+" "+lodash.get(rowData, 'registersData.lastName') : "")
                    }
                }
            },
            {
                name: "status",
                label: "1'st Payment Status",
                options: {
                    filter: false, 
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        if (rowData.type === "CHARGE" && rowData.notifyId === 1) {
                            return "SUCCESS"
                        } else if (rowData.type === "CHARGE" && rowData.notifyId > 1) {
                            return "-"
                        } else if (rowData.type === "RECURRING_UNSUBSCRIBE") {
                            return "-"
                        } else {
                            return "FAIL"
                        }
                    }
                }
            },
            {
                name: "1payment",
                label: "1'st Payment Date",
                options: {
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return ((rowData.type === "CHARGE" && rowData.notifyId === 1) || rowData.type === "FAIL" ? plugins.datetimeFormat(lodash.get(rowData, 'created_at'), "fulldatetime") : "-")
                    }
                }
            },
            {
                name: "recurringStatus",
                label: "Recurring Status",
                options: {
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                        if(rowData.type === "CHARGE" && rowData.notifyId > 1) {
                            return "SUCCESS"
                        } else if (rowData.type === "RECURRING_UNSUBSCRIBE") {
                            return "UNSUBSCRIBE"
                        } else {
                            return "-"
                        }
                    }
                }
            },
            {
                name: "recurringDate",
                label: "Recurring Date",
                options: {
                    customBodyRender: (value, tableMeta) => {
                        const rowIndex = tableMeta.rowIndex;
                        const rowData = this.getRowData(rowIndex);
                            return (rowData.notifyId > 1 || rowData.type === "RECURRING_UNSUBSCRIBE" ? plugins.datetimeFormat(lodash.get(rowData, 'created_at'), "fulldatetime") : "-")
                    }
                }
            }
        ];
        const options = {
            serverSide: true,
            count: tableTotal ? tableTotal : 0,
            page: tableFilter ? tableFilter.page : 0,
            rowsPerPage: rowsPerPage,
            fixedHeader: true,
            selectableRows: "none",
            print: false,
            customToolbar: () => {
                return (
                    <>
                        {plugins.isHasPermission("report[true_money_line_payment_transaction]", "export") && plugins.isHasPackageFeatures('export') &&(
                            <Tooltip title='Export CSV'>
                                <IconButton
                                    id='button-trueMoneyRegisterTable-exportCsv'
                                    className=''
                                    onClick={this.exportCSV.bind(this)}>
                                    <CloudDownload />
                                </IconButton>
                            </Tooltip>
                        )}
                    </>
                );
            },
            download: false,
            filter: false,
            responsive: "scroll",
            rowsPerPageOptions: [1, 5, 10, 20],
            onTableChange: (action, tableState) => {
                let skip,
                    limit,
                    sortBy,
                    sortDir,
                    keyword = "";

                if (tableState.page !== null) {
                    skip = tableState.page;
                }

                if (tableState.rowsPerPage !== null) {
                    limit = tableState.rowsPerPage;
                }

                if (tableState.activeColumn !== null) {
                    sortBy = tableState.columns[tableState.activeColumn].name;
                }
                if (tableState.announceText !== null) {
                    sortDir =
                        tableState.announceText.search("descending") !== -1
                            ? "desc"
                            : "asc";
                }
                if (tableState.searchText !== null || action === "search") {
                    keyword = tableState.searchText;
                    this.delayedCallback(skip, limit, sortBy, sortDir, keyword);
                }
                let actionList = ["changePage", "sort", "changeRowsPerPage"];
                if (actionList.indexOf(action) !== -1) {
                    this.getData(skip, limit, sortBy, sortDir, keyword);
                }
            },
        };
        return (
            <div id='trueMoneyPaymentReport'>
                <form
                    name={FORM_NAME}
                    onSubmit={handleSubmit(this.handleSubmit.bind(this))}
                >
                    <GridContainer>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="startDate"
                                component={CustomDatePicker}
                                type="text"
                                maxDate={startMaxDate}
                                labelText="Start Date"
                                dateFormat="DD-MMM-YY"
                                timeFormat="HH:mm:ss"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="endDate"
                                minDate={endMinDate}
                                maxDate={new Date()}
                                component={CustomDatePicker}
                                type="text"
                                labelText="End Date"
                                dateFormat="DD-MMM-YY"
                                timeFormat="HH:mm:ss"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="lineRegisterType"
                                component={CustomSelect}
                                type="text"
                                labelText="Line OA Type"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                optionsList={lineRegisterTypeList}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="lineDisplayName"
                                component={CustomInput}
                                type="text"
                                labelText="Display Name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="lineOaId"
                                component={CustomInput}
                                type="text"
                                labelText="Basic ID"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="package"
                                component={CustomSelect}
                                type="text"
                                labelText="Price Plan"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                optionsList={packageList}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="type"
                                component={CustomSelect}
                                type="text"
                                labelText="Application Type"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                optionsList={typeList}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="companyName"
                                component={CustomInput}
                                type="text"
                                labelText="Company Name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="name"
                                component={CustomInput}
                                type="text"
                                labelText="Applicant Name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="email"
                                component={CustomInput}
                                type="text"
                                labelText="Applicant E-mail"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="premiumId"
                                component={CustomInput}
                                type="text"
                                labelText="Premium ID"
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="paymentType"
                                component={CustomSelect}
                                type="text"
                                labelText="Payment Type"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                optionsList={paymentTypeList}
                            />
                        </GridItem>
                        <GridItem xs={6} sm={6} md={3} lg={3}>
                            <Field
                                name="paymentStatus"
                                component={CustomSelect}
                                type="text"
                                labelText="Payment Status"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                optionsList={statusList}
                            />
                        </GridItem>

                        <GridItem xs={12} sm={6} md={3} lg={3}>
                            <Button
                                id="button-trueMoneyPaymentReport-clear"
                                onClick={this.clearFilter}
                                style={{ marginRight: "10px", marginTop: "25px" }}
                                size="sm"
                                color="white"
                            >
                                Clear
                            </Button>
                            <Button
                                type="submit"
                                id="button-trueMoneyPaymentReport-submit"
                                style={{ marginTop: "25px" }}
                                size="sm"
                                color="primary"
                            >
                                Submit
                            </Button>
                        </GridItem>
                    </GridContainer>
                </form>
                
                <MuiThemeProvider theme={THEME}>
                    <MUIDataTable
                        key={trueMoneyPaymentReport.tableKey}
                        data={tableData ? tableData : []}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { FORM_FILTER_TRUE_MONEY_PAYMENT } = state.form;
    const { trueMoneyPaymentReport } = state.report;
    const { merchantSetting, package_features } = state.authentication;

    return {
        FORM_FILTER_TRUE_MONEY_PAYMENT,
        trueMoneyPaymentReport,
        merchantSetting,
        package_features
    };
}

const connectedComponent = connect(mapStateToProps)(TrueMoneyPaymentReport);

export default reduxForm({
    form: FORM_NAME,
})(withStyles(style)(connectedComponent));
